import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';
import NewReceipt from '../../../profile/documents/receipt/NewReceipt';

/**
 * Mobile wrapper for NewReceipt – same functionality as desktop with narrow layout.
 * Expects query param: id (customer id)
 */
const MobileNewReceipt = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');

    if (!id) return <Box />;

    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: '100vw',
                boxSizing: 'border-box',
                px: { xs: 0, sm: 1 },
                py: 0.5,
                overflowX: 'hidden'
            }}
        >
            <NewReceipt upid={id} narrow={true} />
        </Box>
    );
};

export default MobileNewReceipt;
